export default __webpack_public_path__ + "static/media/vpbysik.7e1ce844.png";